import { AlertTriangle, Rocket02 } from '@untitled-ui/icons-react';
import { twMerge } from 'tailwind-merge';

import { tNamespace } from '../services/translation';
import { parseCreditData } from '../shared/credits';
import { addCommaSeparator } from '../shared/number';
import { ProgressBar } from './progress-bar';

const t = tNamespace('app.sidebar');
const MAX_PERCENTAGE = 100;

type CreditSidebarProps = {
  availableCredits: number | undefined;
  totalCredits: number | undefined;
  extraCredits?: number;
  className?: string;
};

export function CreditSidebar(props: CreditSidebarProps) {
  const { total, available, used, usedPercentage } = parseCreditData(
    props.availableCredits,
    props.totalCredits,
    props.extraCredits
  );

  const extraCreditCount = props.extraCredits ?? 0;

  // NOTE: free plan no longer available
  // if (isFreePlan) {
  //   return (
  //     <div className="h-14 rounded-md bg-gradient-to-r from-branding-accent-600 to-purple-700 p-[1px]">
  //       <div className="flex h-full items-center justify-between rounded-[5px] bg-white px-4 py-3">
  //         <p className="font-display-4">
  //           {currentCredits == 1 || currentCredits == 0
  //             ? t('oneCredit', { creditsCount: currentCredits })
  //             : t('multipleCredits', { creditsCount: addCommaSeparator(currentCredits) })}
  //         </p>
  //         <Button variant="gradient-premium" size="sm" onClick={redirect}>
  //           {t('upgrade')}
  //         </Button>
  //       </div>
  //     </div>
  //   );
  // }

  // NOTE: this is the old credits with a click to add credits
  // return (
  //   <div className="flex h-12 items-center justify-between rounded-md border border-branding-gray bg-white px-4 py-3">
  //     <p className="font-display-4">
  //       {currentCredits === 1
  //         ? t('oneCredit', { creditsCount: currentCredits })
  //         : t('multipleCredits', { creditsCount: addCommaSeparator(currentCredits) })}
  //     </p>
  //     <IconButton icon={Plus} variant="accent" aria-label={t('addCredits')} onClick={redirect} />
  //   </div>
  // );

  let statusColor = 'border-branding-accent-200 bg-lavander-50';
  let statusColorHover = 'hover:border-branding-accent-200 hover:bg-lavander-100';

  // NOTE: this is a special case where the user doesn't have any credits and on these
  //       cases we can't really calculate ratio, so, we make sure that the ratio is
  //       always 1
  let statusRatio = usedPercentage;
  if (Number.isNaN(statusRatio) || total === 0) {
    statusRatio = 100;
  }

  // reached the end
  if (available <= 0) {
    statusColor = 'border-red-200 bg-red-50';
    // statusColorHover = 'hover:border-red-200 hover:bg-red-50';
    statusColorHover = 'hover:border-branding-accent-200 hover:bg-lavander-100';
  }

  return (
    <div
      className={twMerge(
        'credit-sidebar font-body-2-m transition-bg-color group rounded-md border p-4 duration-100 ease-out',
        statusColor,
        statusColorHover,
        props.className ?? ''
      )}
    >
      <div className="flex w-full flex-col gap-2">
        <div className="flex w-full items-center gap-1">
          <p className="shrink-0">
            {statusRatio >= 100 ? (
              <AlertTriangle className="text-red-600" width={16} height={16} />
            ) : null}
            {statusRatio < 100 ? <Rocket02 width={16} height={16} /> : null}
          </p>
          <p className="min-w-0 text-ellipsis whitespace-nowrap group-hover:truncate">
            {t('creditUsage')}
          </p>
          <p className="font-body-2-r ml-auto shrink-0 opacity-0 transition-opacity duration-100 ease-out group-hover:opacity-100">
            {addCommaSeparator(used)}/{addCommaSeparator(total)}
            {extraCreditCount > 0 ? (
              <span className="font-body-2-m text-green-500"> (+ {extraCreditCount})</span>
            ) : null}
          </p>
        </div>
        {/* NOTE: as we are using percentage now instead of value, we need hard coded value */}
        <ProgressBar current={usedPercentage} total={MAX_PERCENTAGE} minRatio={2} />
      </div>
    </div>
  );
}
